import _Vue from 'vue'
import * as Sentry from '@sentry/vue'

const sentryPlugin = {
  install(vue: typeof _Vue, options: any) {
    if (options.dsn) {
      Sentry.init({
        Vue: vue,
        dsn: options.dsn,
        logErrors: options.env !== 'prod',
        normalizeDepth: 10
      })
    }

    vue.prototype.$sentry = Sentry
  }
}

export default sentryPlugin
